/**
 * Purchase form: one-time vs Auto-Replenish toggle.
 *
 * Auto-Replenish is server-rendered as the default choice with its
 * frequency pills and renewal terms visible. Switching to one-time hides
 * the pills and disables the selling_plan radios so the form submits a
 * one-time purchase.
 */
(function () {
  document.querySelectorAll('[data-purchase-form]').forEach(function (root) {
    var planWrap = root.querySelector('[data-plan-wrap]');
    var planRadios = root.querySelectorAll('[data-plan-radio]');

    function sync() {
      var choice = root.querySelector('[data-purchase-type]:checked');
      var subscribing = choice && choice.value === 'subscribe';
      if (planWrap) planWrap.hidden = !subscribing;
      planRadios.forEach(function (radio) {
        radio.disabled = !subscribing;
      });
    }

    root.querySelectorAll('[data-purchase-type]').forEach(function (radio) {
      radio.addEventListener('change', sync);
    });

    planRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        var priceEl = root.querySelector('[data-plan-price]');
        if (radio.checked && priceEl) priceEl.textContent = radio.getAttribute('data-price');
      });
    });

    sync();
  });

  /**
   * Product gallery: thumbnails and prev/next arrows swap the visible
   * stage image. All images are server-rendered in the DOM; JS only
   * toggles visibility.
   */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var images = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-image]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var stage = gallery.querySelector('.product__stage');
    if (images.length < 2) return;

    var mobile = window.matchMedia('(max-width: 899px)');
    var current = 0;

    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dot]'));

    function markCurrent(index) {
      current = (index + images.length) % images.length;
      thumbs.forEach(function (b, i) {
        b.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
      var counter = gallery.querySelector('[data-gallery-current]');
      if (counter) counter.textContent = current + 1;
    }

    function slidePitch() {
      // Slide width plus the flex gap: measure from real layout.
      return images.length > 1 ? images[1].offsetLeft - images[0].offsetLeft : stage.clientWidth;
    }

    function show(index) {
      markCurrent(index);
      if (mobile.matches && stage) {
        // Mobile: the stage is a scroll-snap strip — scroll to the slide.
        stage.scrollTo({ left: slidePitch() * current, behavior: 'smooth' });
      } else {
        // Desktop: crossfade via visibility classes.
        images.forEach(function (img, i) {
          img.classList.toggle('is-hidden', i !== current);
        });
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });

    gallery.querySelectorAll('[data-gallery-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { show(current - 1); });
    });
    gallery.querySelectorAll('[data-gallery-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { show(current + 1); });
    });

    // Mobile swipe: indicators track the swipe live (no debounce lag).
    if (stage) {
      stage.addEventListener('scroll', function () {
        if (!mobile.matches) return;
        var index = Math.round(stage.scrollLeft / slidePitch());
        if (index !== current) markCurrent(index);
      }, { passive: true });
    }
  });
})();
